<template>
    <div class="meter">
        <div class="title">运营成本构成</div>
        <div class="warp">
            <div id="chart">
                <Charts id="cost" :option="option"/>
            </div>
            <div class="text">
                <div class="all">园区总运营成本：<span>{{Number(cost.firm + cost.tenant).toFixed(2)}} ￥</span></div>
                <div class="tenant"><span></span> 租户能耗成本：<span>{{cost.tenant}} ￥</span></div>
                <div class="tenant"><span></span> 企业能耗成本：<span>{{cost.firm}} ￥</span></div>
            </div>
        </div>
        
    </div>
</template>

<script>
import {EleResize} from '../../../util/a.js'
import * as echarts from 'echarts';
import  Charts  from '../../../components/common/Charts.vue'
export default {
    data(){
        return {
            
        }
    },
    components:{Charts},
    computed:{
        cost(){
            return this.$store.state.project.costOperation
        },
        perent(){
            let firm = ((this.cost.firm / (this.cost.firm + this.cost.tenant)) * 100) .toFixed(2)
            let tenant = ((this.cost.tenant / (this.cost.firm + this.cost.tenant)) * 100).toFixed(2)
            return {
                firm, tenant
            }
        },
        option(){
            return {
                tooltip: {
                    trigger: 'item',
                    formatter: function (params) {
                        return `${params.marker} ${params.data.name} &nbsp;${params.value}%`
					}
                },
                color: [ '#E8684A','#0D94FF', '#9271CB', '#6CCBEC'],
                legend: {
                    orient: 'vertical',
                    left: 'left',
                    show:false
                },
                series: [ 
                    {
                    type: 'pie',
                    radius: ['45%', '65%'],
                    data: [
                        { value: this.perent.firm , name: '企业' },
                        { value: this.perent.tenant , name: '租户' },
                    ],
                    emphasis: {
                        itemStyle: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)',
                        }
                    },
                    itemStyle: {
                        borderWidth: 2,
                        borderColor: '#fff',
                        borderMiterLimit:0,
                        shadowBlur :0
                    },
                    label: {
                        // alignTo: 'edge',
                        formatter: '{time|{c} %}',
                        // formatter: '{name|{b}}\n{time|{c} %}',
                        minMargin: 5,
                        edgeDistance: 10,
                        lineHeight: 15,
                        rich: {
                            time: {
                                fontSize: 16,
                                color: '#0D94FF'
                            }
                        }
                    },
                    }
                ]
            }
        }
    },
    watch:{
        // '$store.state.project.costOperation'(val){
        //     console.log(val);
        //     this.Cost = val
        // }
    },
    mounted(){
        // this.initChart()
    },
    methods:{
        // initChart(){
        //     let chartDom = document.getElementById('chart')
        //     let myChart = echarts.init(chartDom);
            
        //     let listener = ()=>{
		// 		myChart.resize()
		// 	}
		// 	EleResize.on(chartDom, listener)
		// 	myChart.clear()
		// 	myChart.setOption(this.option);
        // },
    }
}
</script>

<style lang="less" scoped>
.meter{
    width: 100%;
    height: 100%;
    padding: 14rem;
    
    .title{
        font-size: 16rem;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #333333;
    }
    .warp{
        width: 100%;
        height: 25.5vh;
        display: flex;
        #chart{
            width: 50%;
            height: 25.5vh;
        }
        .text{
            width: 50%;
            height: 25.5vh;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: flex-start;

            .all{
                font-size: 16rem;
                font-family: Source Han Sans CN;
                font-weight: bold;
                color: #333333;
                padding-bottom: 1vh;
                &>span{
                    font-size: 24rem;
                    color: #0D94FF;
                }
            }
            .tenant{
                font-size: 16rem;
                font-family: Source Han Sans CN;
                font-weight: bold;
                color: #333333;
                line-height: 28px;
                line-height: 26rem;
                height: 26rem;
                &>span:nth-of-type(1){
                    display: inline-block;
                    width:12rem ;
                    height: 12rem;
                    background-color: #0D94FF;
                    border-radius: 2px;
                }
                &>span:nth-of-type(2){
                    font-size: 18rem;
                    color: #0D94FF;
                }
            }
            .tenant:nth-child(3){
                &>span:nth-of-type(1){
                    display: inline-block;
                    width:12rem ;
                    height: 12rem;
                    background-color: #E8684A;
                    border-radius: 2px;
                }
            }
        }
    }
    
}
</style>